import React from 'react';
import '../css/PopUpMentionLegales.css';

/**
 * Composant affichant une popup pour les mentions légales.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Indique si la popup est visible.
 * @param {function} props.onClose - Fonction déclenchée pour fermer la popup.
 */
const PopUpMentionLegales = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h2>Mentions Légales</h2>
                
<div className="join join-vertical w-full">
    <div className="collapse collapse-arrow join-item border-b border-base-300">
        <input type="radio" name="my-accordion-1" defaultChecked={true} />
        <div className="collapse-title text-md font-medium">
            1. Éditeur du site
        </div>
        <div className="collapse-content">
            {/* <p>Le présent site internet, accessible à l’adresse [www.nomdedataroom.com], est édité par la société [Nom de la société], société [forme juridique : SAS, SARL, etc.] au capital de [montant] euros, immatriculée au Registre du Commerce et des Sociétés de [ville] sous le numéro [numéro RCS].</p> */}
            <p className="mt-2">
Logestia.fr
                {/* Siège social : [adresse complète]<br>
                Téléphone : [numéro de téléphone]<br>
                Adresse e-mail : [adresse e-mail de contact]<br>
                Directeur de la publication : [nom, prénom, fonction] */}
            </p>
        </div>
    </div>

    {/* <div className="collapse collapse-arrow join-item border-b border-base-300">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-md font-medium">
            2. Hébergement
        </div>
        <div className="collapse-content">
            <p>Le site est hébergé par [nom de l’hébergeur], société [forme juridique] au capital de [montant] euros, dont le siège social est situé à [adresse complète].</p>
            <p className="mt-2">
                Téléphone : [numéro de téléphone]<br/>
                Adresse e-mail : [adresse e-mail de contact hébergeur]
            </p>
        </div>
    </div> */}

    <div className="collapse collapse-arrow join-item border-b border-base-300">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-md font-medium">
            3. Objet du site
        </div>
        <div className="collapse-content">
            <p>La dataroom "dataroom.agestia.fr" a pour objet de permettre le partage et la consultation sécurisée de documents confidentiels entre avocats et leurs clients, dans le cadre de missions juridiques, contentieuses ou transactionnelles.</p>
        </div>
    </div>

    <div className="collapse collapse-arrow join-item border-b border-base-300">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-md font-medium">
            4. Accès et utilisation du site
        </div>
        <div className="collapse-content">
            <p>L’accès à la dataroom est réservé aux utilisateurs expressément autorisés. Chaque utilisateur s’engage à préserver la confidentialité de ses identifiants d’accès et à respecter les conditions générales d’utilisation fournies par l’éditeur.</p>
            <p className="mt-2">Toute tentative d’accès non autorisée ou d’utilisation frauduleuse des données est strictement interdite et pourra donner lieu à des poursuites.</p>
        </div>
    </div>

    <div className="collapse collapse-arrow join-item border-b border-base-300">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-md font-medium">
            5. Propriété intellectuelle
        </div>
        <div className="collapse-content">
            <p>L’ensemble des éléments composant le site (charte graphique, textes, marques, logos, bases de données, logiciels, etc.) est la propriété exclusive de Logestia.fr ou de ses partenaires.</p>
            <p className="mt-2">Toute reproduction, représentation, ou diffusion totale ou partielle du contenu sans autorisation expresse est interdite.</p>
        </div>
    </div>

    <div className="collapse collapse-arrow join-item border-b border-base-300">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-md font-medium">
            6. Données personnelles
        </div>
        <div className="collapse-content">
            <p>Les données personnelles collectées dans le cadre de l’utilisation du site sont traitées conformément au Règlement Général sur la Protection des Données (RGPD) et à la législation en vigueur.</p>
            <p className="mt-2">L’utilisateur dispose d’un droit d’accès, de rectification, de suppression et d’opposition concernant ses données, qu’il peut exercer en contactant [adresse e-mail de contact pour la protection des données].</p>
            {/* <p className="mt-2">Délégué à la protection des données (DPO) : [nom et coordonnées].</p> */}
        </div>
    </div>

    <div className="collapse collapse-arrow join-item border-b border-base-300">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-md font-medium">
            7. Confidentialité et sécurité
        </div>
        <div className="collapse-content">
            <p>La dataroom met en œuvre toutes les mesures techniques et organisationnelles nécessaires pour garantir la sécurité, la confidentialité et l’intégrité des documents hébergés.</p>
            <p className="mt-2">Toute communication ou diffusion non autorisée des documents partagés est strictement interdite.</p>
        </div>
    </div>

    <div className="collapse collapse-arrow join-item border-b border-base-300">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-md font-medium">
            8. Responsabilité
        </div>
        <div className="collapse-content">
            <p>L’éditeur du site ne saurait être tenu pour responsable des dommages directs ou indirects résultant de l’utilisation de la dataroom, notamment en cas de perte de données, d’interruption de service ou d’accès non autorisé.</p>
            <p className="mt-2">Les utilisateurs assument seuls la responsabilité du contenu qu’ils déposent sur la plateforme.</p>
        </div>
    </div>

    <div className="collapse collapse-arrow join-item">
        <input type="radio" name="my-accordion-1" />
        <div className="collapse-title text-md font-medium">
            9. Droit applicable et juridiction compétente
        </div>
        <div className="collapse-content">
            <p>Les présentes mentions légales sont régies par le droit français.</p>
            <p className="mt-2">Tout litige relatif à l’utilisation du site sera porté devant les tribunaux compétents de Marseille.</p>
        </div>
    </div>
</div>


                <button className="btn btn-success" onClick={onClose}>Fermer</button>
            </div>
        </div>
    );
};

export default PopUpMentionLegales;
